import React from 'react';

import { Paper, Stack, Title } from '@mantine/core';
import { IntentBadge } from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/IntentBadge';
import { SentimentBadge } from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/SentimentBadge';
import { useTranslation } from 'react-i18next';
import { ExtractedData } from 'shared/interfaces/ConversationAnalysis';

interface CallAnalysisProps {
  extractedData: ExtractedData;
}

export function CallAnalysis({ extractedData }: CallAnalysisProps) {
  const { t } = useTranslation();

  return (
    <Paper withBorder p="md" radius="md" h="100%">
      <Title order={4} mb="md">
        {t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.TITLE')}
      </Title>
      <Stack spacing="lg">
        <SentimentBadge sentiment={extractedData.sentimentAnalysis} />
        <IntentBadge intent={extractedData.intentClassification} />
      </Stack>
    </Paper>
  );
}
